const connexion = [
  {
    path: "/",
    name: "connexion",
    component: () => import("@/views/Signin"),
  },
];

const admin = [
  {
    path: "/admin",
    meta: { requiresRoleGroup: ['admin', 'comite', 'administratif'] },
    name: "dashboard",
    component: () => import("@/views/Dashboard"),
  },
  {
    path: "/mon-tableau",
    meta: { requiresRoleGroup: ['expert'] },
    name: "dashboardOnly",
    component: () => import("@/views/DashboardOnly"),
  },
  {
    path: "/finance",
    meta: { requiresRoleGroup: ['admin'] },
    name: "gestionFinanciere",
    component: () => import("@/views/finance/GestionFinanciere.vue"),
  },
  {
    path: "/tableau-de-bord",
    meta: { requiresRoleGroup: ['stagiaire'] },
    name: "tableauDeBord",
    component: () => import("@/views/DashboardStagiaire"),
  },
  {
    path: "/permission",
    meta: { requiresRoleGroup: ['admin'] },
    name: "permissionCreer",
    component: () => import("@/views/userGestion/Permission.vue")
  },
  {
    path: "/role",
    meta: { requiresRoleGroup: ['admin'] },
    name: "roleCreer",
    component: () => import("@/views/userGestion/role.vue")
  },
  {
    path: "/categorie",
    meta: { requiresRoleGroup: ['admin'] },
    name: "categorie",
    component: () => import("@/views/referentiel/categorie.vue")
  },
  {
    path: "/commission",
    meta: { requiresRoleGroup: ['admin'] },
    name: "commission",
    component: () => import("@/views/referentiel/commission.vue")
  },
  {
    path: "/sousCategorie",
    meta: { requiresRoleGroup: ['admin'] },
    name: "sousCategorie",
    component: () => import("@/views/referentiel/sousCategorie.vue")
  },
  {
    path: "/typeFichier",
    meta: { requiresRoleGroup: ['admin'] },
    name: "typeFichier",
    component: () => import("@/views/referentiel/fileType.vue")
  },
  {
    path: "/utilisateur",
    meta: { requiresRoleGroup: ['admin'] },
    name: "utilisateur",
    component: () => import("@/views/userGestion/utilisateur.vue")
  },
  {
    path: "/profil",
    meta: {}, // Accessible à tous les utilisateurs connectés
    name: "profil",
    component: () => import("@/views/userGestion/profilUser.vue")
  },
  {
    path: "/demandes",
    meta: {},
    name: "demandes",
    component: () => import("@/views/demandes/demande.vue")
  },
  {
    path: "/actualites",
    meta: { requiresRoleGroup: ['admin'], requiresPermission: ['PERMISSION_ACTUALITES_VOIR'] },
    name: "actualites",
    component: () => import("@/views/referentiel/actualite.vue")
  },
  {
    path: "/societe",
    meta: { requiresRoleGroup: ['admin'] },
    name: "societe",
    component: () => import("@/views/societes/societe.vue")
  },
  {
    path: "/fonction",
    meta: { requiresRoleGroup: ['admin'] },
    name: "fonction",
    component: () => import("@/views/societes/fonction.vue")
  },
  {
    path: "/mesSociete",
    meta: { requiresRoleGroup: ['expert'] },
    name: "mesSociete",
    component: () => import("@/views/societes/mesSociete.vue")
  },
  {
    path: "/addSociete",
    meta: { requiresRoleGroup: ['expert'] },
    name: "addSociete",
    component: () => import("@/views/societes/addSociete.vue")
  },
  {
    path: "/demandesSociete",
    meta: { },
    name: "demandesSociete",
    component: () => import("@/views/demandes/demandeSociete.vue")
  },
  {
    path: "/maintientPP",
    meta: { },
    name: "maintientPP",
    component: () => import("@/views/demandes/physiqueMaintient.vue")
  },
  {
    path: "/maintientPM",
    meta: { },
    name: "maintientPM",
    component: () => import("@/views/demandes/societeMaintien.vue")
  },
  {
    path: "/message",
    meta: {}, // Accessible à tous les utilisateurs connectés
    name: "message",
    component: () => import("@/views/mails/message.vue")
  },
  {
    path: "/newsletters",
    meta: { requiresRoleGroup: ['admin'] },
    name: "newsletters",
    component: () => import("@/views/mails/newsletters.vue")
  },
  {
    path: "/fiche",
    meta: { requiresRoleGroup: ['expert'] },
    name: "fiche",
    component: () => import("@/views/expertComptable/ficheAdhesion.vue")
  },
  {
    path: "/dirigeants",
    meta: { requiresRoleGroup: ['admin'] },
    name: "dirigeants",
    component: () => import("@/views/societes/dirigeant.vue")
  },
  {
    path: "/mesCotisations",
    meta: { requiresRoleGroup: ['expert'] }, 
    name: "mesCotisations",
    component: () => import("@/views/expertComptable/mesCotisations.vue")
  },
  {
    path: "/maintien",
    meta: { requiresRoleGroup: ['expert'] },
    name: "mesMaintien",
    component: () => import("@/views/expertComptable/maintien/index.vue")
  },
  {
    path: "/cotisationSociete",
    meta: { requiresRoleGroup: ['expert'] },
    name: "cotisationSociete",
    component: () => import("@/views/expertComptable/cotisationSociete.vue")
  },
  {
    path: "/correction",
    meta: { requiresRoleGroup: ['expert'] },
    name: "correction",
    component: () => import("@/views/expertComptable/correction.vue"),
    props: true
  },
  {
    path: "/importationPersonne",
    meta: { requiresRoleGroup: ['admin'] },
    name: "importationPersonne",
    component: () => import("@/views/imports/importPhysique.vue"),
    props: true
  },
  {
    path: "/importationSociete",
    meta: { requiresRoleGroup: ['admin'] },
    name: "importationSociete",
    component: () => import("@/views/imports/importMorale.vue"),
    props: true
  },
  {
    path: "/signataire",
    meta: { requiresRoleGroup: ['admin'] },
    name: "signataire",
    component: () => import("@/views/signataire.vue"),
    props: true
  },
  {
    path: "/banque",
    meta: { requiresRoleGroup: ['admin'] },
    name: "banque",
    component: () => import("@/views/banque.vue"),
    props: true
  },
  {
    path: "/Cotisations",
    meta: { requiresRoleGroup: ['admin', 'comite'], requiresPermission: ['PERMISSION_COTISATIONS_VOIR'] },
    name: "Cotisations",
    component: () => import("@/views/Cotisation.vue"),
    props: true
  },
  {
    path: "/formation",
    meta: { requiresRoleGroup: ['admin','comite'], requiresPermission: ['PERMISSION_FORMATION_VOIR'] },
    name: "formation",
    component: () => import("@/views/formation.vue"),
    props: true
  },
  {
    path: "/formations-externes",
    meta: { requiresRoleGroup: ['admin'] },
    name: "formations-externes",
    component: () => import("@/views/admin/formationsExternes.vue"),
    props: true
  },
  {
    path: "/mes-formations",
    meta: { requiresRoleGroup: ['expert'] },
    name: "mes-formations",
    component: () => import("@/views/expertComptable/mesFormations.vue"),
    props: true
  },
  {
    path: "/journalisation",
    meta: { requiresRoleGroup: ['admin'] },
    name: "journalisation",
    component: () => import("@/views/fichierLogs.vue")
  },
  {
    path: "/list-stagiaires",
    meta: { requiresRoleGroup: ['expert'] },
    name: "stagiaires",
    component: () => import("@/views/stagiaires/mesStagiaires.vue")
  },
  {
    path: "/rapports-stages",
    meta: { requiresRoleGroup: ['stagiaire'] },
    name: "rapports",
    component: () => import("@/views/stagiaires/rapportStagiaire.vue")
  },
  {
    path: "/mes-rapports",
    meta: { requiresRoleGroup: ['expert'] },
    name: "mesRapports",
    component: () => import("@/views/stagiaires/rapportMaitre.vue")
  },
  {
    path: "/suivi-mensuel",
    meta: { requiresRoleGroup: ['stagiaire'] },
    name: "suiviMensuel",
    component: () => import("@/views/stagiaires/presenceStagiaire.vue")
  },
  {
    path: "/rapports-generales",
    meta: { requiresRoleGroup: ['admin'] },
    name: "rapportAdmin",
    component: () => import("@/views/Rapport.vue")
  },
  {
    path: "/oecca-expert",
    meta: { requiresRoleGroup: ['admin'] },
    name: "oecca-expert",
    component: () => import("@/views/userGestion/oeccaExpert.vue")
  },
  {
    path: "/document-expert",
    meta: { requiresRoleGroup: ['expert'] },
    name: "documentExpert",
    component: () => import("@/views/expertComptable/documentExpert.vue")
  },
  {
    path: "/verification-matricule",
    meta: { requiresRoleGroup: ['admin'] },
    name: "verificationMatricule",
    component: () => import("@/views/VerificationMatricule.vue")
  },
  {
    path: "/comite-position",
    meta: { requiresRoleGroup: ['admin'] },
    name: "comitePosition",
    component: () => import("@/views/referentiel/Comite-Position.vue")
  },
  {
    path: "/comite-membre",
    meta: { requiresRoleGroup: ['admin'] },
    name: "comiteMembre",
    component: () => import("@/views/referentiel/Comite-Membre.vue")
  },
  {
    path: "/chambre-commission",
    meta: { requiresRoleGroup: ['admin'] },
    name: "chambreCommission",
    component: () => import("@/views/referentiel/Chambre-Commission.vue")
  },
  {
    path: "/album",
    meta: { requiresRoleGroup: ['admin'] },
    name: "album",
    component: () => import("@/views/mediathèque/Album.vue")
  },
  {
    path: "/document",
    meta: { requiresRoleGroup: ['admin'] },
    name: "document",
    component: () => import("@/views/mediathèque/Document.vue")
  },
  {
    path: "/video",
    meta: { requiresRoleGroup: ['admin'] },
    name: "video",
    component: () => import("@/views/mediathèque/Video.vue")
  },
  {
    path: "/fichier-expert",
    meta: { requiresRoleGroup: ['admin'] },
    name: "fichierExpert",
    component: () => import("@/views/mediathèque/FichierExpert.vue")
  },
  {
    path: "/pieces-administratives",
    meta: { requiresRoleGroup: ['expert'] },
    name: "piecesAdministratives",
    component: () => import("@/views/expertComptable/PiecesAdministratives.vue")
  },
  {
    path: "/newRenouvellement",
    meta: { requiresRoleGroup: ['expert'] },
    name: "newRenouvellement",
    redirect: { name: "mesMaintien" }
  },
  {
    path: "/mesRenouvellements",
    meta: { requiresRoleGroup: ['expert'] },
    name: "mesRenouvellements",
    redirect: { name: "mesMaintien" }
  },
  {
    path: "/societeRenouvellement",
    meta: { requiresRoleGroup: ['expert'] },
    name: "societeRenouvellement",
    redirect: { name: "mesSociete" }
  },
  {
    path: "/maintien-personnel/:demandeId?",
    meta: { requiresRoleGroup: ['expert'] },
    name: "maintienPersonnelProcess",
    component: () => import("@/views/expertComptable/maintien/oldProcess.vue"),
    props: true
  },
  {
    path: "/renouvellementSociete/:societeId/:demandeId?",
    meta: { requiresRoleGroup: ['expert'] },
    name: "renouvellementSociete",
    component: () => import("@/views/societes/UpdateRenouvellementSociete.vue"),
    props: true
  },
  {
    path: "/setting",
    meta: { requiresRoleGroup: ['admin'] },
    name: "setting",
    component: () => import("@/views/Setting.vue"),
    props: true
  },
  {
    path: "/dettes-creances",
    meta: { requiresRoleGroup: ['admin'] },
    name: "importationSolde",
    component: () => import("@/views/admin/GestionSoldes.vue"),
    props: true
  },
];

export default [
  {
    path: "/auth",
    component: () => import("@/views/Signin"),
    children: connexion,
  },
  {
    path: "/",
    component: () => import("@/views/espace/Admin"),
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    children: admin,
  },
  {
    path: "/forget",
    name: "forget",
    component: () => import("@/views/PasswordForget"),
  },


];
